import { jsxs, jsx } from 'react/jsx-runtime';
import { addPropsToSVG } from '../helpers/add-props-to-svg.esm.js';

const _PenUnderline = (props)=>jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            jsx("rect", {
                width: 18,
                height: 2,
                x: 3,
                y: 20,
                fill: "currentColor",
                rx: 0.5,
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            }),
            jsx("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeWidth: props.strokeWidth || 1.5,
                d: "m13.8889 5.5556-7.5718 7.5718a2.0001 2.0001 0 0 0-.547 1.0219l-.6966 3.483c-.035.1749.1193.3291.2942.2942l3.483-.6966a2.0005 2.0005 0 0 0 1.022-.547l7.5717-7.5718m-3.5555-3.5555 2.1413-2.1414c.7811-.781 2.0474-.781 2.8285 0l.7271.7271c.781.781.781 2.0474 0 2.8285l-2.1414 2.1413m-3.5555-3.5555 3.5555 3.5555",
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            })
        ]
    });
const PenUnderline = addPropsToSVG(_PenUnderline);

export { PenUnderline };
